import _ from 'lodash'
import moment from 'moment'

import basketHelpers from '../helpers/basketHelpers'
import roomTypes from '../configs/roomTypes'

import config from '../configs/config'

const { harvestBasketData } = config
const withChildAges = _.get(config, 'brandConfig.secure.withChildAges', false)

const summary = (state = {
  brandConfig: {},
  title: '',
  checkinDate: '',
  checkoutDate: '',
  parkDate: '',
  party: '',
  roomDescriptions: [],
  onChange: () => {}
}, action) => {
  switch (action.type) {
    case 'GET_AVAILABILITY_PAGE_DATA': {
      const packageRatesReply = _.get(window, 'packageRatesReply', [])

      // As we technically haven't actually got a ticket selected at this point. Let's just get the
      // 1st package rate & use that as our basis for all the linked data we will need.
      const eventProductId = _.get(packageRatesReply, 'packageRates[0].links.eventProducts.ids[0]', null)
      const ticketName = _.get(packageRatesReply, ['linked', 'eventProducts', eventProductId, 'name'], '')
      const roomRates = _.get(packageRatesReply, 'meta.context.roomRates', {})
      const ticketRates = _.get(packageRatesReply, 'meta.context.ticketRates', {})
      const checkinDate = roomRates.checkinDate || null
      const checkoutDate = roomRates.checkoutDate || null
      const rooms = roomRates.rooms || null

      const { adults, children, infants } = basketHelpers.maybeConvertPartyComp(withChildAges ? roomRates : ticketRates)
      const startDate = _.get(packageRatesReply, 'meta.context.ticketRates.startDate', null)

      const roomDescriptions = basketHelpers.getRoomsDescriptions(roomTypes, rooms)
      const brandConfig = _.get(window, 'searchFormService.brandConfig', {})

      const linkedTicketRates = _.cloneDeep(Object.values(_.get(packageRatesReply, ['linked', 'ticketRates']), {}))
      const linkedEventProducts = _.get(packageRatesReply, ['linked', 'eventProducts'], {})

      linkedTicketRates.forEach(rate => {
        const eventProduct = _.get(rate, 'links.eventProducts.ids[0]')
        if (linkedEventProducts[eventProduct]) {
          rate.name = linkedEventProducts[eventProduct].name
        }
      })

      const ticketDescriptions = basketHelpers.getTicketDescriptions(linkedTicketRates)

      return Object.assign({}, state, {
        adults,
        brandConfig,
        checkinDate: checkinDate ? moment(checkinDate).format('Do MMMM YYYY') : null,
        checkoutDate: checkoutDate ? moment(checkoutDate).format('Do MMMM YYYY') : null,
        children,
        infants,
        initialProps: true,
        parkDate: startDate ? moment(startDate).format('Do MMMM YYYY') : null,
        roomDescriptions,
        ticketDescriptions,
        title: ticketName
      })
    }

    case 'GET_MOREINFORMATION_PAGE_DATA':
    case 'GET_PAYMENT_PAGE_DATA':
    case 'GET_UPGRADES_PAGE_DATA': {
      const ticketName = _.get(harvestBasketData, 'ticket.name', null)
      const checkinDate = _.get(harvestBasketData, 'hotel.checkinDate', null)
      const rooms = _.get(harvestBasketData, 'rooms', null)
      const partyComp = basketHelpers.maybeConvertPartyComp(_.get(harvestBasketData, 'ticket', {}))
      const { adults, children, infants, startDate } = partyComp
      const roomDescriptions = basketHelpers.getRoomsDescriptions(roomTypes, rooms)
      const brandConfig = _.get(window, 'searchFormService.brandConfig', {})
      return Object.assign({}, state, {
        adults,
        brandConfig,
        checkinDate: checkinDate ? moment(checkinDate).format('Do MMMM YYYY') : null,
        children,
        infants,
        initialProps: true,
        parkDate: startDate ? moment(startDate).format('Do MMMM YYYY') : null,
        roomDescriptions,
        title: ticketName
      })
    }
    default:
      return state
  }
}

export default summary
